module.exports = __webpack_public_path__ + "img/vk.56b757c3.svg";